export default __webpack_public_path__ + "static/media/close.495af076.svg";